<template>
  <svg
    style="enable-background: new 0 0 48 48"
    version="1.1"
    viewBox="0 0 48 48"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="dehumidifierIcon"
  >
    <g id="_x34_8x48" />
    <g id="icons">
      <g>
        <path
          class="st0"
          d="M24,18.6c-2.6-3.9-5.4-8.5-7-15.6C13.5,18.7,4,22.2,4,33c0,7.2,5.8,13,13,13c7.2,0,13-5.8,13-13    c0-1.1-0.1-2.1-0.3-3"
        />
        <path class="st0" d="M28.5,26c-0.8-1.7-1.8-3.3-2.9-5" />
        <path class="st0" d="M21,39c0-11.5,21-8.8,21-19v-4" />
        <polyline class="st0" points="38,20 42,16 46,20   " />
        <path class="st0" d="M14,32c0-11.5,21-8.8,21-19V9" />
        <polyline class="st0" points="31,13 35,9 39,13   " />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "DehumidifierIcon",
};
</script>

<style lang="stylus" scoped>
.st0 {
  fill: none;
 
  stroke-width: 4;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}

.st1 {
  fill: none;
 
  stroke-width: 4;
  stroke-miterlimit: 10;
}

.st2 {
  fill: none;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}

.dehumidifierIcon {
  fill: currentColor;
}

path, polyline {
  stroke: currentColor;
  stroke-width: 4;
}
</style>
